import { render, staticRenderFns } from "./IntroCode.vue?vue&type=template&id=3913550e&scoped=true&"
import script from "./IntroCode.vue?vue&type=script&lang=ts&"
export * from "./IntroCode.vue?vue&type=script&lang=ts&"
import style0 from "./IntroCode.vue?vue&type=style&index=0&id=3913550e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3913550e",
  null
  
)

export default component.exports